
module App {
  "use strict";
  
  export class MainVM {
    private o: Orchestrator;

    private _lastSyncTime: Date;

    constructor (orchestrator: Orchestrator) {
      this.o = orchestrator;
    }

    public activate(): void {
    }

    public saveToLocal() {
      let storageItem: string = `storage-${this.o.currentUserName()}`;

      let someData: string = 'sample';
      let someDataJson: string = JSON.stringify(someData);

      window.localStorage.setItem(storageItem, someDataJson);
    }

  }
}
